import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';

/**
 * Persisted tenant billing record returned by the API.
 */
export class TenantBillingRecordDto extends BaseDto {
  enableMetering!: boolean;
  meteringProviderCustomerId?: string | null;
  billingProviderCustomerId?: string | null;
  /** Start of the trial window. Null if this tenant is not on a trial. */
  trialStartsAt?: string | null;
  /**
   * Instant capture starts emitting for this tenant (trial end when
   * `trialStartsAt` is set). Null means this tenant emits nothing.
   */
  meteringStartsAt?: string | null;
  meteringProviderMetadata?: Record<string, unknown> | null;
  billingProviderMetadata?: Record<string, unknown> | null;
}
